import { SAVE, FETCHING, NOT_FETCHING } from 'src/store/actions/requestTypesActions';

const initialState = {
  fetching: false,
  list: null // null || array
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCHING: {
      return { ...state, fetching: true };
    }
    case SAVE: {
      return { ...state, list: action.payload, fetching: false };
    }
    case NOT_FETCHING: {
      return { ...state, fetching: false };
    }
    default: {
      return state;
    }
  }
};
